import React from 'react';

import { SVGComponentProps } from './svg.types';

const ManageWorkspacesSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M10.565 16.6308C10.794 16.6841 10.8149 16.9839 10.592 17.0583L9.27528 17.4916C5.96695 18.5583 4.22528 17.6666 3.15028 14.3583L2.08362 11.0666C1.01695 7.75827 1.90028 6.00827 5.20862 4.9416L5.47595 4.85307C5.87881 4.71965 6.2744 5.12502 6.16549 5.53519C6.13481 5.65074 6.10482 5.76954 6.07528 5.8916L5.25862 9.38327C4.34195 13.3083 5.68362 15.4749 9.60862 16.4083L10.565 16.6308Z"
          fill={fill}
        />
        <path
          d="M14.3088 2.67493L12.9171 2.34993C10.1338 1.69159 8.47548 2.23326 7.50048 4.24993C7.25048 4.75826 7.05048 5.37493 6.88381 6.08326L6.06714 9.57493C5.25048 13.0583 6.32548 14.7749 9.80048 15.5999L11.2005 15.9333C11.6838 16.0499 12.1338 16.1249 12.5505 16.1583C15.1505 16.4083 16.5338 15.1916 17.2338 12.1833L18.0505 8.69992C18.8671 5.21659 17.8005 3.49159 14.3088 2.67493ZM12.7421 11.1083C12.6671 11.3916 12.4171 11.5749 12.1338 11.5749C12.0838 11.5749 12.0338 11.5666 11.9755 11.5583L9.55048 10.9416C9.21714 10.8583 9.01714 10.5166 9.10048 10.1833C9.18381 9.84993 9.52548 9.64993 9.85881 9.73326L12.2838 10.3499C12.6255 10.4333 12.8255 10.7749 12.7421 11.1083ZM15.1838 8.29159C15.1088 8.57492 14.8588 8.75826 14.5755 8.75826C14.5255 8.75826 14.4755 8.74993 14.4171 8.74159L10.3755 7.71659C10.0421 7.63326 9.84214 7.29159 9.92548 6.95826C10.0088 6.62493 10.3505 6.42493 10.6838 6.50826L14.7255 7.53326C15.0671 7.60826 15.2671 7.94992 15.1838 8.29159Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ManageWorkspacesSVG;
